import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./core_styles/core.scss";
import "./core_styles/fonts.scss";
import "./index.scss";
import HistoryPage from "./pages/history/history";
import GalleryPage from "./pages/gallery/gallery";
import CupPage from "./pages/cup/cup";
import Encyclopedia from "./pages/encyclopedia/encyclopedia";
import NewsPage from "./pages/news/news";
import Header from "./components/header/header";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

const returnToRoot = () => {
	window.location.href = "/";
	return null;
};

root.render(
	<React.StrictMode>
		<div className="header_wrapper">
			<Header></Header>
		</div>
		<BrowserRouter>
			<Routes>
				<Route path="/istoriya" element={<HistoryPage></HistoryPage>} />
				<Route path="/galereya" element={<GalleryPage></GalleryPage>} />
				<Route path="/cup" element={<CupPage></CupPage>} />
				<Route path="/news" element={<NewsPage></NewsPage>} />
				<Route
					path="/encyclopedia"
					element={<Encyclopedia></Encyclopedia>}
				/>
			</Routes>
		</BrowserRouter>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
